import React, { useEffect, useState } from 'react';
import SiteView from './Site';
import DisplayCustomerSite from '../../display/displayCustomerSite';
import Site, { CreateSiteOptions } from 'src/interfaces/api/Site';
import useSite from 'src/hooks/api/useSite';
import { useNotifier } from 'src/components/NotificationCenter/AlertNotificationCenter';

const SiteContainer = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [site, setSite] = useState<Site>();
  const { getSiteOfLegacyCustomer, update } = useSite();
  const { addNotification } = useNotifier();

  const { id } = props.match.params;

  useEffect(() => {
    setLoading(true);

    getSiteOfLegacyCustomer(id)
      .then(async (fetchedSite) => {
        if (!fetchedSite) {
          throw new Error('Aucun site trouvé pour ce client');
        }

        setSite(fetchedSite);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, [id]);

  const handleChangeSite = async (options: CreateSiteOptions) => {
    if (!site?.id) {
      throw new Error();
    }

    const newSite = await update(site.id, options);
    setSite(newSite);

    addNotification({
      title: 'Enregistrement effectué avec succès !',
      alertProps: { color: 'success' },
    });

    return newSite;
  };

  if (loading) {
    return <div>Chargement ...</div>;
  }

  if (error || !site) {
    return <DisplayCustomerSite {...props} />;
  }

  return <SiteView site={site} onChange={handleChangeSite} />;
};

export default SiteContainer;
